import { render, staticRenderFns } from "./AdapterFrame.vue?vue&type=template&id=5c4a5076"
import script from "./AdapterFrame.vue?vue&type=script&lang=js"
export * from "./AdapterFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports